import { createContext, useContext, ReactNode } from 'react'

export interface DashboardSidebarValue {
  sidebarCollapsed: boolean
}

const DashboardSidebarContext = createContext<DashboardSidebarValue | undefined>(undefined)

export const useDashboardSidebar = () => {
  const ctx = useContext(DashboardSidebarContext)
  return ctx
}

export const DashboardSidebarProvider = ({
  sidebarCollapsed,
  children,
}: {
  sidebarCollapsed: boolean
  children: ReactNode
}) => (
  <DashboardSidebarContext.Provider value={{ sidebarCollapsed }}>
    {children}
  </DashboardSidebarContext.Provider>
)
